module.exports = __webpack_public_path__ + "img/sh_260410_1.c5234fa4.jpg";